/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JourneyType,
    JourneyTypeFromJSON,
    JourneyTypeFromJSONTyped,
    JourneyTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface JourneyTypeCriteriaOutput
 */
export interface JourneyTypeCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof JourneyTypeCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {JourneyType}
     * @memberof JourneyTypeCriteriaOutput
     */
    value?: JourneyType;
}

export function JourneyTypeCriteriaOutputFromJSON(json: any): JourneyTypeCriteriaOutput {
    return JourneyTypeCriteriaOutputFromJSONTyped(json, false);
}

export function JourneyTypeCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyTypeCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : JourneyTypeFromJSON(json['value']),
    };
}

export function JourneyTypeCriteriaOutputToJSON(value?: JourneyTypeCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': JourneyTypeToJSON(value.value),
    };
}


